import script from "./CursosOfficeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CursosOfficeComponent.vue?vue&type=script&setup=true&lang=js"

import "./CursosOfficeComponent.vue?vue&type=style&index=0&id=73c672e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c672e8"]])

export default __exports__